module.exports = __webpack_public_path__ + "img/finance_18.aa3294a1.png";